import { world } from '../languages';
import { WORLD_GROUPS } from '../languages/constants';

const isSupplementaryWorld = (): boolean => {
    return WORLD_GROUPS.SUPPLEMENTARY.includes(world);
};

export default isSupplementaryWorld;
